  <!-- 考试成绩管理 -->
  <template>
    <div class="fuzzy-matching-box">
      <!-- 考试成绩管理 -->
      <div class="fuzzy-matching-top">
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
            <el-form-item label="考试:">
              <el-input v-model="Dform.examName" placeholder=''></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="姓名:">
              <el-input v-model="Dform.studentName" placeholder=''></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="学号:">
              <el-input v-model="Dform.studentNo" placeholder=''></el-input>
            </el-form-item>
          </el-col>
  
          <el-col :span="5">
          </el-col>
        </el-row>
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
            <el-form-item label="学校:">
              <el-input v-model="Dform.schoolName" placeholder=''></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="年级:">
              <el-input v-model="Dform.gradeName" placeholder=''></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="班级:">
              <el-input v-model="Dform.className" placeholder=''></el-input>
            </el-form-item>
          </el-col>
  
          <el-col :span="5">
          </el-col>
          <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
        </el-row>
      </div>
      <div class="fuzzy-matching-content">
        <el-button type="text" class="textButton"  @click="leadingfile">导入考试成绩</el-button>
        <el-button type="text" class="textButton"  @click="xiazaiclick">下载成绩模板</el-button>
        <!-- <el-button type="text" @click="">导出学生数据</el-button> -->
      </div>
  
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
          <el-table stripe :border="true" v-loading="loading" :header-cell-style="{ background: '#EDF6FF', color: '#000', }" ref="multipleTable"
            :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column prop="courseName" label="考试">
            </el-table-column>
            <el-table-column prop="gradeName" label='年级'>
            </el-table-column>
            <el-table-column prop="clazzName" label='班级'>
            </el-table-column>
            <el-table-column prop="studentName" label="姓名">
            </el-table-column>
            <el-table-column prop="studentNo" label="学号">
            </el-table-column>
            <el-table-column prop="gradeRankNo" label="年名">
            </el-table-column>
            <el-table-column prop="clazzRankNo" label="班名">
            </el-table-column>
            <el-table-column prop="courseFull" label="总分">
            </el-table-column>
            <el-table-column prop="courseScore1" label="语文">
            </el-table-column>
            <el-table-column prop="courseScore2" label="数学">
            </el-table-column>
            <el-table-column prop="courseScore3" label="英语">
            </el-table-column>
            <el-table-column prop="courseScore4" label="科学">
            </el-table-column>
            <el-table-column prop="courseScore5" label="历社">
            </el-table-column>
            <el-table-column prop="created" label="发布时间">
            </el-table-column>
            <el-table-column prop="authorName" label="发布人">
            </el-table-column>
            <el-table-column label="操作" min-width="100">
              <template #default="scope">
                <!-- <div v-if="scope.row.id == userId"> -->
                  <el-button type="text" class="textButton" size="small" @click="reviseClick(scope.row)">修改</el-button>
                  <el-button type="text" class="shanchuBtn" size="small" @click="deleteClick(scope.row)">删除</el-button>
                <!-- </div> -->
              </template>
            </el-table-column>
  
          </el-table>
  
          <div class="block-fenye">
            <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
              :total="1" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </el-row>
  
      </div>
  
      <div class="dialog-box" v-if="dialogVisible">
        <el-dialog v-model="dialogVisible" title="导入考试成绩" :before-close="handleClose">
          <el-form ref="form" :model="fileForm" :rules="rules" label-width="80px">
            <!-- <el-form-item label="考试" prop="">
              <el-input v-model="fileForm.address"></el-input>
            </el-form-item> -->
            <el-form-item label="年级" prop="classes">
              <el-select filterable v-model="fileForm.classes" placeholder="请选择活动区域" @change="classClick">
                <el-option :label="item.gradeName" :value="item.gradeId" v-for="item in gradeDataList" :key="item.value"></el-option>
                <!-- <el-option label="测试111" value="1"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="班级" prop="classes2">
              <el-select filterable v-model="fileForm.classes2" placeholder="请选择活动区域">
                <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <div class="upload-lef">
              <span class="upload-title" style="width: 80px;">上传：</span>
              <input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
            </div>
          </el-form>
  
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="handleClose">返回</el-button>
              <el-button type="primary" @click="submitForm">
                提交
              </el-button>
            </span>
          </template>
        </el-dialog>
      </div>
      <Revise   v-if="ReviseShow" :reviseItem="reviseItem" :objLookTeacher="objLookTeacher" @backClick="backClick"></Revise>
    </div>
  </template>
  
  <script>
  import { JxtattendanceList,examScoreImport,examScoreBaseInfo,examScoreDelete } from '@/assets/api/schoollog';
  import { gradeList, findClassList ,GettecherIdlistNew} from '@/assets/api/renyuan';
  import { findTeacherInfo } from '@/assets/api/renyuan';
  import Revise from './revise/index.vue'

  
  export default {
    components: {
      Revise
    },
    data() {
      return {
        loading:true,
        Dform: {
          className: "",
          gradeName: "",
          studentName: "",
          examName: "",
          schoolName: "",
          studentNo: "",
        },
        tableData: [
          {
            title: '1'
          }
        ],
        total: "",
        pageInfo: {
          pageSize: "10",
          page: "1",
        },
        theuserValue: 'ff245e1e-8347-4bd4-a714-88d6f0641c96',
        theuserList: [],
        tempFile: "", //文件
        titleValue: '',
        DeviceAddShow: false,
        addShow: false,
        detailsObj: {},
        Deviceidobj: {},
        userId: JSON.parse(localStorage.getItem('user')).id,
        dialogVisible: false,
        fileForm: {
          address: '',
          classes: '',
          classes2: '',
        },
        gradeDataList: [],
        classList: [],
        tempFile: "", //文件
        objLookTeacher: {},
        reviseItem: {},
        ReviseShow: false
      };
    },
    created() {
      this.JxtattendanceListSearch()
      this.LookTeacher()
    },
    mounted() {
  
    },
    methods: {
      xiazaiclick(){
      window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/score.xls'

    },
    getList(){
      console.log(this.objLookTeacher.id,this.objLookTeacher.schoolId, 'sln');
      GettecherIdlistNew(this.objLookTeacher.id,this.objLookTeacher.schoolId).then((res) => {
      console.log(res, 'sln新加考试成绩导入，班级，年级接口查询');
        this.gradeDataList = res.data.data
      })
    },
      LookTeacher() {
        const params = {
          userId: JSON.parse(localStorage.getItem('user')).id,
        }
        findTeacherInfo(params).then((res) => {
          this.objLookTeacher = res.data.data
          console.log(res.data.data, '查看当前登录人权限');
          // if (this.objLookTeacher.schoolId != '' && this.objLookTeacher.schoolId != null) {
          //   this.schoolClick()
          // }
         this.getList()

         }).catch((err) => {
          console.log(err);
        })
      },
      handleClose() {
        this.dialogVisible = false
        this.fileForm = {}
        this.JxtattendanceListSearch()
      },
      submitForm() {
        if (
          // this.fileForm.address != '' &&
          this.fileForm.classes != '' &&
          this.fileForm.classes2 != '' &&
          this.tempFile != ''
        ) {
          console.log(this.fileForm, '提交');
          let index = this.tempFile.name.lastIndexOf(".");
          let fileName = this.tempFile.name.substr(index + 1);
          var filetypes = [
            "jpg",
            "png",
            "gif",
            "jpeg",
            "doc",
            "ppt",
            "xls",
            "pdf",
            "docx",
            "xlsx",
          ];
          if (filetypes.includes(fileName)) {
            if (this.tempFile) {
              let fileSize = this.tempFile.size / (1024 * 1024 * 60);
              if (this.tempFile.name) {
                let formData = new FormData();
                console.log(formData, 8888888);
                formData.append("file", this.tempFile);
                console.log(this.tempFile, formData.getAll('file'));
  
                console.log(   this.fileForm.classes2,
                  this.fileForm.address,
                  this.fileForm.classes,
                  this.objLookTeacher.schoolId ,);
                examScoreImport(
                  formData,
                  this.fileForm.classes2,
                  this.fileForm.address,
                  this.fileForm.classes,
                  this.objLookTeacher.schoolId ,
                  JSON.parse(localStorage.getItem('user')).id,
                ).then((res) => {
                  console.log(res);
                  this.JxtattendanceListSearch()
                  this.$message({
                    message: '导入成功',
                    type: 'success'
                  });
                  this.handleClose()
                }).catch((err) => {
                  // console.log();
                  // ElMessage.error("上传失败")
                  this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
                })
  
  
              }
            }
          } else {
            ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
          }
        } else {
          this.$message({
            message: '弹框内全部为必填！',
            type: 'warning'
          });
        }
      },
      getFile(event) {
        this.tempFile = event.target.files[0];
      },
      leadingfile() {
        this.dialogVisible = true
  
      },
      // 新增按钮
      //   AddClick () {
      //     console.log('新增学生');
      //     this.titleValue = '新增学生'
      //     this.addShow = true
      //   },
      backClick () {
        this.JxtattendanceListSearch()
        this.ReviseShow = false
      },
      reviseClick (item) {
        console.log('修改');
        let params = {
          id: item.id
        }
        examScoreBaseInfo(params).then((res)=> {
          console.log(res);
          this.reviseItem = res.data.data
          console.log(this.reviseItem ,5555555);
          this.ReviseShow = true 
        }).catch((err)=> {

        })
      },
  
      //删除
        deleteClick(item){
          console.log(item,'删除');
          const params ={
            id:item.id 
          }
          examScoreDelete(params).then((res) => {
            console.log(res,222);
  
            // ElMessage.success('')
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.JxtattendanceListSearch()
          }).catch((err) => {
            console.log(err,111);
            ElMessage.error('删除失败')
          })
        },
      schoolClick() {
        this.fileForm.classes = ''
        this.fileForm.classes2 = ''
        let params = {
          page: '1',
          pageSize: '999',
        }
        gradeList(params, this.objLookTeacher.schoolId).then((res) => {
          console.log(res, '年级列表');
          this.gradeDataList = res.data.data;
        }).catch((err) => {
          console.log(err);
        })
      },
      classClick() {
        this.fileForm.classes2 = ''
        // let params = {
        //   page: '1',
        //   pageSize: '999',
        // }
        // findClassList(params, this.fileForm.classes).then((res) => {
        //   console.log(res, '班级列表');
        //   this.classList = res.data.data;
        // }).catch((err) => {
        //   console.log(err);
        // })
        this.gradeDataList.forEach((item,index)=> {
          if ( item.gradeId == this.fileForm.classes ) {
            console.log(item,666666);
            this.classList = item.list
          }
        })
      },
  
  
  
      // 列表
      JxtattendanceListSearch() {
        const params = {
          className: this.Dform.className,
          examName: this.Dform.examName,
          gradeName: this.Dform.gradeName,
          schoolName: this.Dform.schoolName,
          studentName: this.Dform.studentName,
          studentNo: this.Dform.studentNo,
          page: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize,
          userId: JSON.parse(localStorage.getItem('user')).id,
        }
        JxtattendanceList(params).then((res) => {
          console.log(res.data.data.list, '考试成绩');
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.loading = false
  
        }).catch((err) => {
          console.log(err, '学生管理失败');
  
        })
      },
      entrylogClick() {
        this.JxtattendanceListSearch()
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageInfo.page = val
          this.JxtattendanceListSearch()
      },
    },
  };
  </script>
    
  <style scoped lang="scss">
  .fuzzy-matching-box {
    padding-top: 20px;
    // overflow: hidden;
    overflow: auto;
    width: 100%;
    height: 96%;
    background-color: #fff;
    border-radius: 8px;
  
    .title-top {
      padding: 20px 20px;
    }
    
    .textButton {    
     font-size: 15px ;
     font-weight: 700;
   }
    .fuzzy-matching-top {
      height: 130px;
      background-color: #fff;
      border-radius: 8px;
  
      .top-first-line {
        /deep/ {
          .el-form-item--small .el-form-item__label {
            // background-color: red;
            font-size: 16px;
          }
  
          .el-select--small {
            width: 100%
          }
  
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;
          }
  
          .el-input {
            width: 100%;
            height: 35px;
          }
        }
      }
  
      .the-second-line {
        margin-top: 15px;
        position: relative;
  
        .query-button {
          position: absolute;
          right: 300px;
          padding: 16px 24px;
  
          // top: 50%;
          // transform: translate(0,-50%);
          // background-color: #1677FF;
        }
  
      }
  
      /deep/ {
        .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;
        }
      }
  
    }
  
    .fuzzy-matching-content {
      height: 20px;
      line-height: 20px;
      margin-bottom: 10px;
      font-size: 18px !important;
  
      /deep/ {
        .el-button {
          margin-left: 50px;
          font-size: 16px;
  
        }
      }
    }
  
    .fuzzy-matching-bottom {
      // position: absolute;
      padding: 20px;
      .textButton {    
     
        font-size: 15px ;
        font-weight: 700;
      }
      .shanchuBtn{

        font-size: 15px ;
        font-weight: 700;
        color: red;
      }
  
      /deep/ {
        .el-table th.el-table__cell>.cell {
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 15px;
          font-weight: 700;
        }
  
        .el-table td.el-table__cell div {
          text-align: center;
          height: 40px;
          line-height: 40px;
          border: 0;
          font-size: 16px;
        }
  
        .el-table:not(.el-table--border) .el-table__cell {
          border: 0;
        }
  
        .el-button--small {
          font-size: 15px;
          margin: 0;
          padding: 0;
        }
  
        .fuzzy-matching-box .fuzzy-matching-bottom .el-button--small {
          font-size: 16px !important;
        }
      }
  
      .block-fenye {
        margin-left: 1000px;
        margin-top: 15px;
      }
    }
  
  
  
    .upload-lef {
      margin-left: 20px;
      font-size: 14px;
  
      .upload-title {
        // width: 80px ;
        display: inline-block;
        text-align: right;
      }
    }
  
    .el-table tr {
      font-size: 20px;
    }
  
  }
  
  .dialog-box {
    /deep/ {
      .el-dialog {
        width: 500px;
      }
  
      .el-dialog__body {
        // height: 75%;
        // width: 250px;
        max-height: 300px;
        // min-height: 350px;        
        overflow: auto;
      }
  
      // .el-form {
      //     height: ;
      //     overflow: auto;
      //     background-color: red;
      // }
      .el-input--small {
        width: 250px;
      }
  
      .el-select .el-input__inner {
        height: 35px;
        line-height: 35px;
      }
  
      .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
      }
  
      .el-input__inner {
        height: 35px;
        line-height: 35px;
      }
  
      .el-radio.el-radio--small .el-radio__inner {
        width: 14px;
        height: 14px;
      }
  
      .el-input__wrapper {
        height: 35px;
        line-height: 35px;
        
      }
  
      .el-date-editor.el-input,
      .el-date-editor.el-input__wrapper {
        height: 35px !important;
      }
      .el-select--small .el-select__wrapper{
        height: 35px;
        width: 250px;
      }
    }
  }

  </style>
  